import { declOfNum } from '@/commons/helpers';

export const MESSAGES = {
  REQUIRED: 'Обязательное поле',
  MIN_LENGTH: (num) => `Минимум ${num} ${declOfNum(num, 'символ', 'символа', 'символов')}`,
  MAX_LENGTH: (num) => `Максимум ${num} ${declOfNum(num, 'символ', 'символа', 'символов')}`,
  MIN_MAX_VALUE: (min, max) => `Значение может быть от ${min} до ${max}`,
  INCORRECT_FIRSTNAME: 'Некорректное имя',
  INCORRECT_LASTNAME: 'Некорректная фамилия',
  INCORRECT_EMAIL: 'Некорректный адрес эл. почты',
  INCORRECT_PHONE: 'Некорректный номер телефона',
  EMAIL_MATCH: 'Не существует пользователя с таким адресом эл. почты',
  START_SPACES: 'Нельзя использовать пробел в начале',
  EMAIL_DOES_NOT_EXIST: 'С указанным адресом электронной почты не связан ни один активный пользователь',
};

export const NO_ACCESS_MESSAGE = 'У вас недостаточно прав доступа';
